import React from 'react';

import { FormattedMessage } from 'react-intl';
import styles from './decision_separator.module.scss';

export const DecisionSeparator = () => (
  <span className={styles.separator}>
    <FormattedMessage id="decision/components/decision-separator/DecisionSeparator.tsx/1" />
  </span>
);
